import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';

export const HEADER_IMAGES_PROPTYPES = {
    mobile: PropTypes.string,
    tablet: PropTypes.string,
    desktop: PropTypes.string,
    twok: PropTypes.string,
};

export const HEADER_PROPTYPES = {
    images: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
    attribution: PropTypes.oneOfType([
        PropTypes.string,
        EBPropTypes.translation,
    ]),
    shouldShowCustomHeader: PropTypes.bool,
    customContentCtaLabel: PropTypes.string,
    customContentCtaLink: PropTypes.string,
    customContentCtaPrefix: PropTypes.string,
    customLinkLabel: PropTypes.string,
};
